import { ApplicationInitializeService } from './core/services/application-initialize-service/application-initialize.service';

export function initializationFactory(initializeService: ApplicationInitializeService): () => Promise<void> {
  return () => {
    return new Promise(resolve => {
      initializeService.initialize();
      resolve();
    });
  };
}
